export default __webpack_public_path__ + "static/media/masdrLogoWhite.00363c7f.svg";